<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  disabled: { type: Boolean, default: true },
});

const emit = defineEmits(['back', 'deliver']);
const { t } = useI18n();
</script>

<template>
  <nav
    class="fixed bottom-0 left-0 z-30 hidden w-full items-center justify-between border-t border-lais-border-soft bg-white p-[5px] shadow-lais-soft max-[700px]:flex"
    data-test="sales-registration-mobile-footer"
  >
    <LaisPrimaryButton
      variant="link"
      icon="i-lucide-arrow-left"
      data-test="sales-registration-mobile-back"
      @click="emit('back')"
    >
      {{ t('SALES.ACTIONS.BACK') }}
    </LaisPrimaryButton>
    <LaisPrimaryButton
      size="lg"
      :disabled="props.disabled"
      data-test="sales-registration-mobile-deliver"
      @click="emit('deliver')"
    >
      <span class="inline-flex items-center gap-2">
        {{ t('SALES.FOOTER.MOBILE_DELIVER') }}
        <span class="i-lucide-arrow-right size-4" aria-hidden="true" />
      </span>
    </LaisPrimaryButton>
  </nav>
</template>
